import * as React from "react";
import { HStack, StackProps } from "@chakra-ui/react";
import { useCurrentCase, useOnline } from "duck";
import { Export, EmergencyDrugs } from "./components";

const Actions: React.FC<StackProps> = props => {
  const online = useOnline();
  const upToDate = useCurrentCase(state => state.status === "normal");

  const disabled = !online || !upToDate;

  return (
    <HStack spacing="4" {...props}>
      <Export disabled={disabled} />
      <EmergencyDrugs />
    </HStack>
  );
};

export default Actions;
